import React, { forwardRef, useState } from 'react'
import { Dropdown as SemanticDropdown } from 'semantic-ui-react'

export const NO_MORE_OPTIONS_MESSAGE = 'No more options available'

const selectableOptions = options =>
    (options || []).filter(
        option =>
            option &&
            !option.disabled &&
            option.value !== undefined &&
            option.value !== null,
    )

export const remainingSelectableOptions = (options, selected) => {
    const selectedList = Array.isArray(selected) ? selected : []
    return selectableOptions(options).filter(
        option => !selectedList.includes(option.value),
    )
}

const appliesAllSelectedRule = ({ multiple, allowAdditions, options }) =>
    Boolean(multiple) &&
    !allowAdditions &&
    selectableOptions(options).length > 0

const AppDropdownComponent = (props, ref) => {
    const {
        multiple,
        allowAdditions,
        options,
        value,
        open,
        onOpen,
        onClose,
        onChange,
        noResultsMessage,
        ...rest
    } = props

    const ruleApplies = appliesAllSelectedRule({
        multiple,
        allowAdditions,
        options,
    })
    const parentControlsOpen = open !== undefined
    const [uncontrolledOpen, setUncontrolledOpen] = useState(false)
    const allSelected =
        ruleApplies && remainingSelectableOptions(options, value).length === 0
    let menuOpen = open
    if (ruleApplies && !parentControlsOpen) {
        menuOpen = uncontrolledOpen
    }

    const handleOpen = (event, data) => {
        if (!parentControlsOpen) setUncontrolledOpen(true)
        onOpen?.(event, data)
    }

    const handleClose = (event, data) => {
        if (!parentControlsOpen) setUncontrolledOpen(false)
        onClose?.(event, data)
    }

    const handleChange = (event, data) => {
        onChange?.(event, data)
        if (remainingSelectableOptions(options, data?.value).length !== 0) {
            return
        }
        if (!parentControlsOpen) setUncontrolledOpen(false)
        onClose?.(event, { ...data, open: false })
    }

    return (
        <SemanticDropdown
            ref={ref}
            multiple={multiple}
            allowAdditions={allowAdditions}
            options={options}
            value={value}
            open={menuOpen}
            onOpen={ruleApplies ? handleOpen : onOpen}
            onClose={ruleApplies ? handleClose : onClose}
            onChange={ruleApplies ? handleChange : onChange}
            noResultsMessage={
                allSelected ? NO_MORE_OPTIONS_MESSAGE : noResultsMessage
            }
            {...rest}
        />
    )
}

export const AppDropdown = forwardRef(AppDropdownComponent)

AppDropdown.Divider = SemanticDropdown.Divider
AppDropdown.Header = SemanticDropdown.Header
AppDropdown.Item = SemanticDropdown.Item
AppDropdown.Menu = SemanticDropdown.Menu
AppDropdown.SearchInput = SemanticDropdown.SearchInput
AppDropdown.Text = SemanticDropdown.Text
